import Vue from 'vue';
import Router from 'vue-router';
import axios from 'axios'
// import store from '../store/index';
import routes from './router';
import { isLogin } from './accountUnit';
import tool from '../common/js/tool';
import { errorNotify } from '@/common/mixin/common';
import i18n from '@/common/lang/i18n';

Vue.use(Router);
const router = new Router({
  mode: 'history',
  // 解决vue框架页面跳转有白色不可追踪色块的bug
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
  routes,
});


let timeStamp = new Date().getTime()
let interval = 1000;   // 60*1000
router.beforeEach((to, from, next) => {

  let count = sessionStorage.getItem("count")||0;
  let now = new Date().getTime();
  // 防止频繁请求 ，每个60秒请求一次
  if(now - timeStamp > interval){
    timeStamp = new Date().getTime()
    axios.get(`${tool.getBaseUrl()}/version.js?_=${Math.random()}`).then(response => {
      console.log("当前版本", process.env);
      console.log("当前版本 response", response.data);
      // 当前环境为线上环境 (测试或者生产)
      if(process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'sit'){
        if (parseInt(process.env.VUE_APP_VERSION) !== response.data) {
          sessionStorage.setItem("count",count++);
          window.location.reload(true);
        }
      }
    }).catch(err => {
      console.error(err);
    });
  }

  let logined = isLogin();
  if (logined) {
    // 如果用户已经登录了则不允许再调转到登录页面
    if (to.name === 'login') {
      next({
        name: 'home',
      });
      return;
    }
  }

  if (to.meta.requireAuth) {
    // 已经登录
    if (logined) {
      next();
    } else {
      next({
        path: '/login',
        // 将跳转的路由path作为参数，登录成功后跳转到该路由
        query: { redirect: to.fullPath },
      });
    }
  } else {
    next();
  }
  if (to.name === 'exchange' || to.name === 'exchange-symbol') {
    if (!tool.hasClass(document.documentElement, 'exchange-page')) {
      tool.addClass(document.documentElement, 'exchange-page');
    }
  } else {
    tool.removeClass(document.documentElement, 'exchange-page');
  }

  // change title back to default
  if (from.name == 'exchange' && to.name != 'exchange') {
    document.title = 'GRXTrade';
  }

  /* let timer = setTimeout(() => {
    let storageToken = localStorage.getItem('token');
    let token = store.getters.getToken;
    // 用户在其他页面退出或重新登录了，则刷新页面
    if (token && storageToken !== token) {
      window.location.reload(true);
    }
    clearTimeout(timer);
  }, 200); */
  // next();
});

router.afterEach((to, from) => {
  if (!to.meta.keepAlive) {
    window.scrollTo(0, 0);
  }
});

// 解决Loading chunk (\d)+ failed问题
router.onError((error) => {
  const pattern = /Loading chunk chunk-(\w){8} failed/g;
  const patt = new RegExp(pattern);
  const isChunkLoadFailed = patt.test(error.message);
  // const isChunkLoadFailed = error.message.match(pattern);
  if (isChunkLoadFailed) {
    // 用路由的replace方法，并没有相当于F5刷新页面，失败的js文件并没有从新请求，会导致一直尝试replace页面导致死循环，而用 location.reload 方法，相当于触发F5刷新页面，虽然用户体验上来说会有刷新加载察觉，但不会导致页面卡死及死循环，从而曲线救国解决该问题
    location.reload();
    // const targetPath = $router.history.pending.fullPath;
    // $router.replace(targetPath);
  }
});

export default router;
